export enum StrengthFinderPosition {
  FIRST = 1,
  SECOND,
  THIRD,
  FOURTH,
  FIFTH,
}
